import { render, staticRenderFns } from "./AccountApplicationForm.vue?vue&type=template&id=bca8ed3c&scoped=true&"
import script from "./AccountApplicationForm.vue?vue&type=script&lang=ts&"
export * from "./AccountApplicationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca8ed3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bca8ed3c')) {
      api.createRecord('bca8ed3c', component.options)
    } else {
      api.reload('bca8ed3c', component.options)
    }
    module.hot.accept("./AccountApplicationForm.vue?vue&type=template&id=bca8ed3c&scoped=true&", function () {
      api.rerender('bca8ed3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountApplication/accountApplicationForm/AccountApplicationForm.vue"
export default component.exports